export default "__VITE_ASSET__CsKJfvgE__"